import gql from 'graphql-tag';

export default gql`
    mutation DeleteCustomerParent($input: CustomerParentDeleteRequest) {
        deleteCustomerParent(input: $input) {
            errors
        }
    }
`;
